/**
 * @name clamp
 *
 * @description Clamps a number within the given lower and upper bounds.
 *
 * @example
 * import { clamp } from '@workbench/core';
 *
 * clamp(-10, -5, 5); // => -5
 * clamp(10, -5, 5); // => 5
 */
export const clamp = (number: number, min: number, max: number): number => {
  return Math.min(Math.max(number, min), max);
};
